import React, { useState, useEffect } from 'react';
import { showError, showSuccess } from '../utils/alertas';

const IS_PROD = true; 
const API_BASE_URL = IS_PROD ? 'https://sigoapi.jhe-etes.com.br/api' : 'http://localhost:3001/api';

function EditarContratoModal({ isOpen, onClose, contrato, onSuccess }) {
  // 1. ESTADOS
  const [codigoContrato, setCodigoContrato] = useState('');
  const [nome, setNome] = useState('');
  const [objetoResumidoETE, setObjetoResumidoETE] = useState('');
  const [valor, setValor] = useState('');
  const [statusId, setStatusId] = useState('');
  const [listaStatus, setListaStatus] = useState([]); 
  const [loading, setLoading] = useState(false);

  // 2. BUSCA STATUS DA TABELA status_obras (CORRIGIDO)
  useEffect(() => {
    if (isOpen) {
      async function carregarStatus() {
        try {
          const token = localStorage.getItem('token'); // 🔐 Pega o token
          
          // 🛠️ MUDANÇA: URL alterada de /status para /status_obras
          const response = await fetch(`${API_BASE_URL}/status_obras`, {
            headers: {
              'Authorization': `Bearer ${token}` // 🔐 Envia o token
            }
          });

          if (response.ok) {
            const dados = await response.json();
            setListaStatus(dados);
          } else {
            console.error("Erro na API de status:", response.status);
          }
        } catch (error) {
          console.error("Erro ao carregar status_obras:", error);
        }
      }
      carregarStatus();
    }
  }, [isOpen]);

  // 3. SINCRONIZAÇÃO
  useEffect(() => {
    if (contrato) {
      setCodigoContrato(contrato.codigo_contrato || '');
      setNome(contrato.nome || '');
      setObjetoResumidoETE(contrato.objetoResumidoETE || contrato.descricao || '');
      setValor(contrato.valorContratoCadastroETE || 0);
      setStatusId(contrato.status_id || ''); 
    }
  }, [contrato]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem('token');

    try {
      const payload = { 
        codigo_contrato: codigoContrato,
        nome: nome,
        objetoResumidoETE: objetoResumidoETE,
        valor: valor,
        status_id: statusId 
      };

      const response = await fetch(`${API_BASE_URL}/contratos/${contrato.id}`, {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        await showSuccess("Sucesso", "Contrato atualizado com sucesso!");
        onSuccess();
        onClose();
      } else {
        const errorData = await response.json();
        showError("Erro", errorData.message || "Falha ao salvar.");
      }
    } catch (error) {
      showError("Erro", "Erro de conexão com o servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden transform transition-all scale-100">
        
        <div className="bg-slate-50 px-6 py-4 flex justify-between items-center border-b border-gray-100">
          <div>
            <h2 className="text-lg font-black text-gray-800 flex items-center gap-2">
              <span className="text-xl">⚙️</span> Configurações do Contrato
            </h2>
            {/*<p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Sincronizado com o sistema</p>*/}
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-red-500 transition-all text-2xl font-light">&times;</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5 ml-1">Código SAP</label>
              <input 
                type="text"
                className="w-full p-3 border-2 border-gray-100 rounded-xl bg-gray-50 focus:border-sabesp-blue outline-none font-mono text-sm transition-all"
                value={codigoContrato}
                onChange={(e) => setCodigoContrato(e.target.value)}
                required
              />
            </div>

            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5 ml-1">Status da Obra</label>
              <div className="relative">
                <select 
                  className="w-full p-3 border-2 border-gray-100 rounded-xl bg-gray-50 focus:border-sabesp-blue outline-none text-sm font-bold appearance-none cursor-pointer transition-all"
                  value={statusId}
                  onChange={(e) => setStatusId(e.target.value)}
                  required
                >
                  <option value="">Selecione um status...</option>
                  {listaStatus.map((s) => (
                    <option key={s.id} value={s.id}>{s.nome}</option>
                  ))}
                </select>
                <div className="absolute right-3 top-3.5 pointer-events-none text-gray-400 text-xs">▼</div>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5 ml-1">Nome do Contrato</label>
            <input 
              type="text"
              className="w-full p-3 border-2 border-gray-100 rounded-xl bg-gray-50 focus:border-sabesp-blue outline-none text-sm font-bold transition-all"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5 ml-1">Escopo Técnico</label>
            <textarea 
              className="w-full p-4 border-2 border-gray-100 rounded-2xl bg-gray-50 h-28 focus:border-sabesp-blue outline-none resize-none text-sm leading-relaxed transition-all"
              value={objetoResumidoETE}
              onChange={(e) => setObjetoResumidoETE(e.target.value)}
              placeholder="Descreva o objetivo do contrato..."
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1.5 ml-1">Valor Total (R$)</label>
            <div className="relative">
                <span className="absolute left-4 top-3 text-gray-400 font-bold text-sm">R$</span>
                <input 
                  type="number"
                  step="0.01"
                  className="w-full p-3 pl-12 border-2 border-gray-100 rounded-xl bg-gray-50 focus:border-sabesp-blue outline-none font-mono font-bold text-gray-700 transition-all"
                  value={valor}
                  onChange={(e) => setValor(e.target.value)}
                />
            </div>
          </div>

          <div className="flex justify-end items-center gap-3 pt-4 border-t border-gray-50">
            <button type="button" onClick={onClose} className="px-5 py-2.5 text-gray-400 font-bold hover:text-gray-600 transition-colors text-sm">Cancelar</button>
            <button 
              type="submit" 
              disabled={loading} 
              className="px-8 py-2.5 bg-sabesp-blue text-white font-bold rounded-xl hover:bg-[#082855] transition-all shadow-lg hover:shadow-blue-200/50 disabled:opacity-50 active:scale-95"
            >
              {loading ? 'Salvando...' : '💾 Atualizar Contrato'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditarContratoModal;